module.exports = __webpack_public_path__ + "img/dne-exchange-lg.57918c1c.jpg";